import { Component } from '@angular/core';
import { GridsterItem } from 'angular-gridster2';

@Component({
  selector: 'markant-platform-add-widget-widget',
  templateUrl: './add-widget-widget.component.html',
  styleUrls: ['./add-widget-widget.component.scss'],
})
export class AddWidgetComponent {
  static readonly gridsterDef: GridsterItem = {
    id: 'addWidgetItem',
    rows: 1,
    cols: 1,
    x: 0, //@override
    y: 0, //@override
    dragEnabled: false,
  };
}
